import { render, staticRenderFns } from "./emailSoftbullet.vue?vue&type=template&id=4bb7e7f4&scoped=true"
import script from "./emailSoftbullet.vue?vue&type=script&lang=js"
export * from "./emailSoftbullet.vue?vue&type=script&lang=js"
import style0 from "./emailSoftbullet.vue?vue&type=style&index=0&id=4bb7e7f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb7e7f4",
  null
  
)

export default component.exports